import { mergeHead, type HeadDescriptor } from '../shared/seo/HeadDescriptor.js';
import { defaultHead } from '../shared/seo/defaultHead.js';
import { breadcrumbJsonLd, type SiteInfo } from '../shared/seo/jsonld.js';
import type { CategoriaData } from './models/entities/CategoriaData.js';

/**
 * El `<head>` de una sección, compartido por el loader (HTML del server) y la vista
 * (`useHead` al saltar de una sección a otra desde el menú, donde no corre ningún loader).
 *
 * `page` entra en el canonical: la página 2 de una sección grande es una URL propia e
 * indexable.
 */
export function headDeCategoria(
  category: CategoriaData['category'],
  site: SiteInfo,
  page = 1,
): HeadDescriptor {
  const path = page > 1 ? `/${category.urlKey}?page=${page}` : `/${category.urlKey}`;

  return mergeHead(defaultHead(site, path), {
    title: `${category.name} — ${site.name}`,
    description: category.description ?? `Las notas de ${category.name} en ${site.name}.`,
    jsonLd: [
      breadcrumbJsonLd([
        { name: 'Portada', url: `${site.url}/` },
        { name: category.name, url: `${site.url}/${category.urlKey}` },
      ]),
    ],
  });
}
